<template>
  <div class="tax-type-modal">
    <form action="" @submit.prevent="submitDocumentTypeData">
      <div class="card-body">
        <div class="form-group row">
          <label class="col-sm-4 col-form-label input-label">{{ $t('settings.document_types.name') }} <span class="text-danger"> *</span></label>
          <div class="col-sm-7">
            <base-input
              ref="name"
              :invalid="$v.formData.name.$error"
              v-model="formData.name"
              type="text"
              @input="$v.formData.name.$touch()"
            />
            <div v-if="$v.formData.name.$error">
              <span v-if="!$v.formData.name.required" class="form-group__message text-danger">{{ $tc('validation.name_required') }}</span>
              <span v-if="!$v.formData.name.minLength" class="form-group__message text-danger"> {{ $tc('validation.name_min_length', $v.formData.name.$params.minLength.min, { count: $v.formData.name.$params.minLength.min }) }} </span>
            </div>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-sm-4 col-form-label input-label">{{ $t('settings.document_types.attach') }} <span class="text-danger"> *</span></label>
          <div class="col-sm-7">
            <base-select
                v-model="selectedOption"
                :invalid="selectedOption"
                :options="attachOptions"
                :allow-empty="false"
                :show-labels="false"
                :tabindex="5"
                :placeholder="$t('settings.document_types.select_attach')"
                label="name"
                track-by="id"
            />
            <div v-if="$v.selectedOption.$error">
              <span v-if="!$v.selectedOption.required" class="form-group__message text-danger">{{ $tc('validation.required') }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer">
        <base-button
          :outline="true"
          class="mr-3"
          color="theme"
          type="button"
          @click="closeDocumentTypeModal"
        >
          {{ $t('general.cancel') }}
        </base-button>
        <base-button
          :loading="isLoading"
          color="theme"
          :disabled="isSubmitDisabled"
          icon="save"
          type="submit"
        >
          {{ !isEdit ? $t('general.save') : $t('general.update') }}
        </base-button>
      </div>
    </form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { validationMixin } from 'vuelidate'
const { required, minLength, between, maxLength } = require('vuelidate/lib/validators')
export default {
  mixins: [validationMixin],
  data () {
    return {
      isEdit: false,
      isLoading: false,
      attachOption:[
        {name:'Invoice'},{name:'PO'},{name:'Profile'},{name:'Prepayment'},
      ],
      selectedOption:null,
      formData: {
        id: null,
        name: null,
        attach:null
      },
    }
  },
  computed: {
    ...mapGetters('modal', [
      'modalDataID',
      'modalData',
      'modalActive'
    ]),
    ...mapGetters('documentType', [
      'attachOptions',
    ]),
    isSubmitDisabled() {
      return this.$v.$invalid;
    }
  },
  validations: {
    formData: {
      name: {
        required,
        minLength: minLength(3)
      },
    },
    selectedOption:{
       required 
    }
  },
  
  async mounted () {
    this.$refs.name.focus = true
    if (this.modalDataID) {
      this.isEdit = true
      this.setData()
    }
  },
  methods: {
    ...mapActions('modal', [
      'closeModal',
      'resetModalData'
    ]),
    ...mapActions('documentType', [
      'updateDocumentType',
      'addDocumentType'
    ]),
    resetFormData () {
      this.formData = {
        id: null,
        name: null,
        attach:null
      }
      this.selectedOption= null
      this.$v.formData.$reset()
    },
    async submitDocumentTypeData () {
      this.$v.formData.$touch()

      if (this.$v.$invalid) {
        return true
      }

      this.isLoading = true
      let response
      if(this.selectedOption){
        this.formData.attach = this.selectedOption.name

      }
      if (!this.isEdit) {
        response = await this.addDocumentType(this.formData)
      } else {
        response = await this.updateDocumentType(this.formData)
      }
      if (response.data) {
         if (!this.isEdit) {
          window.toastr['success'](this.$t('settings.document_types.created_message'))
        } else {
          window.toastr['success'](this.$t('settings.document_types.updated_message'))
        }
        this.closeDocumentTypeModal()
        this.isLoading = false
        return true
      }
      window.toastr['error'](response.data.error)
    },
    async setData () {
      this.formData = {
        id: this.modalData.id,
        name: this.modalData.name,
      }
      this.selectedOption = this.modalData.attachOption
    },
    closeDocumentTypeModal () {
      this.resetModalData()
      this.resetFormData()
      this.closeModal()
    }
  }
}
</script>
